<template>
  <div class="detail-container main-width">
    <h2 class="detail-title">{{ detailContent.name }}</h2>
    <div class="detail-base">
      <span
        >发布时间：{{
          detailContent.publishTime && detailContent.publishTime.split(" ")[0]
        }}</span
      >
      <span>浏览量：{{ detailContent.hit }}</span>
    </div>
    <div class="detail-content">
      <div v-html="detailContent.content"></div>
    </div>
    <el-card class="detail-pdf" v-if="detailContent.pdf">
      <pdf-dom :pdfUrl="projectFileUrl + detailContent.pdf"></pdf-dom>
    </el-card>
    <div class="detail-attachments">
      <div class="attachments-list">
        <div
          class="attachments-item"
          v-for="(attachment, index) in detailContent.attachments"
          :key="attachment.path"
        >
          <a
            :href="projectFileUrl + attachment.path"
            :download="attachment.name"
          >
            <i class="el-icon-download"></i>
            {{ `附件${index + 1}：${attachment.name}` }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contentFind, contentHit } from "@/api/common/content"
import PdfDom from "@/components/VuePdf"
export default {
  data() {
    return {
      detailContent: {},
    }
  },
  props: {},
  components: {
    PdfDom,
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      let id = this.$route.params.id
      let info = {
        contentBean: { id },
      }
      this.getSingleData(info)
    },
    async getSingleData(params) {
      const res = await contentFind(params)
      if (res.status == 200) {
        this.detailContent = res.data
        contentHit(params)
        this.$nextTick(() => {
          this.changeVideoImgMaxHeight()
          window.addEventListener("resize", () => {
            this.changeVideoImgMaxHeight()
          })
        })
      }
    },
    // video和img给了max-width，等比例给个max-Height
    changeVideoImgMaxHeight() {
      const fatherWidth = document.querySelector(".detail-content")
      let videoArr
      let imgArr
      if (fatherWidth) {
        videoArr = fatherWidth.querySelectorAll("video")
        imgArr = fatherWidth.querySelectorAll("img")
      }
      if (videoArr && videoArr.length) {
        videoArr.forEach((item) => {
          const width = item.width
          const height = item.height
          if (width && height) {
            item.style.maxHeight =
              (Number(height) / Number(width)) *
                Number(fatherWidth.clientWidth) +
              "px"
          }
        })
      }

      if (imgArr && imgArr.length) {
        imgArr.forEach((item) => {
          const width = item.getAttribute("width")
          const height = item.getAttribute("height")
          if (width && height) {
            item.style.maxHeight =
              (Number(height) / Number(width)) *
                Number(fatherWidth.clientWidth) +
              "px"
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.detail-container {
  .detail-title {
    font-size: 28px;
    text-align: center;
    width: 86%;
    margin: 0 auto;
  }
  .detail-base {
    border-bottom: 1px dashed #dae0ee;
    padding: 18px 0;
    text-align: center;
    span {
      margin: 0 20px;
      color: #6c757d;
      font-size: 14px;
    }
  }
  .detail-content {
    padding: 20px 0;
    ::v-deep img {
      max-width: 100% !important;
    }
    ::v-deep video {
      max-width: 100% !important;
    }
  }
  .modules-title {
    color: #9a9a9a;
    margin: 10px 0;
    padding: 10px 0;
  }
  .detail-attachments {
    margin-top: 40px;
    .attachments-list {
      display: flex;
      .attachments-item {
        a {
          display: block;
          color: #303030;
          line-height: 50px;
          border-radius: 50px;
          border: 1px solid #cccccc;
          padding: 0 20px;
          font-size: 14px;
          margin-right: 24px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .detail-container {
    .detail-title {
      font-size: 20px;
    }
    .detail-base {
      padding: 14px 0;
      span {
        font-size: 12px;
      }
    }
    .detail-image {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
      .el-image {
        width: 100%;
        height: auto;
      }
    }
    .detail-content {
      padding: 14px 0;
    }
    .detail-attachments {
      margin-top: 30px;
      .attachments-list {
        display: flex;
        flex-direction: column;
        .attachments-item {
          a {
            display: inline-block;
            color: #303030;
            line-height: 30px;
            border-radius: 50px;
            border: 1px solid #cccccc;
            padding: 0 20px;
            font-size: 12px;
            margin-right: 0;
            margin-bottom: 14px;
          }
        }
      }
    }
  }
}
</style>
